import { render, staticRenderFns } from "./ReaderSettings.vue?vue&type=template&id=2f3e9844&scoped=true"
import script from "./ReaderSettings.vue?vue&type=script&lang=js"
export * from "./ReaderSettings.vue?vue&type=script&lang=js"
import style0 from "./ReaderSettings.vue?vue&type=style&index=0&id=2f3e9844&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-load_d49922f226348ede918ce6b4a43f88e2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3e9844",
  null
  
)

export default component.exports